import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

import { scrollTop } from '../../utils/utils';
import './directory-item.styles.scss';

const DirectoryItem = ({ category }) => {
  const { imageUrl, title, overline, route } = category;

  return (
    <Link className="directory-item" to={route} onClick={scrollTop}>
      <span
        className="directory-item-image"
        style={{ backgroundImage: `url(${imageUrl})` }}
      />

      <span className="directory-item-content">
        {overline && (
          <span className="directory-item-overline">{overline}</span>
        )}
        <h2 className="directory-item-title">{title}</h2>
        <span className="directory-item-cta">
          Découvrir
          <span className="directory-item-arrow" aria-hidden="true">
            <BsArrowRight />
          </span>
        </span>
      </span>
    </Link>
  );
};

export default DirectoryItem;
